var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgP2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_2.svg",
    "data-name": "2.svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 370,
    height: 207,
    viewBox: "0 0 370 207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #cacfec;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill-rule: evenodd;\n      }\n\n      .cls-1 {\n        filter: url(#filter);\n      }\n\n      .cls-2 {\n        filter: url(#filter-2);\n      }\n\n      .cls-3 {\n        fill: #fff;\n        opacity: 0.5;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "filter",
    x: 775,
    y: 1868,
    width: 370,
    height: 205.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feImage", {
    preserveAspectRatio: "none",
    x: 775,
    y: 1868,
    width: 370,
    height: 205.5,
    result: "image",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzcwIiBoZWlnaHQ9IjIwNS41IiB2aWV3Qm94PSIwIDAgMzcwIDIwNS41Ij4KICA8ZGVmcz4KICAgIDxzdHlsZT4KICAgICAgLmNscy0xIHsKICAgICAgICBmaWxsOiB1cmwoI2xpbmVhci1ncmFkaWVudCk7CiAgICAgIH0KICAgIDwvc3R5bGU+CiAgICA8bGluZWFyR3JhZGllbnQgaWQ9ImxpbmVhci1ncmFkaWVudCIgeDE9IjgyLjI1IiB4Mj0iMjg3Ljc1IiB5Mj0iMjA1LjUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjZmIwMDU0Ii8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2Y1NWIyYSIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+CiAgPHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iMzcwIiBoZWlnaHQ9IjIwNS41Ii8+Cjwvc3ZnPgo="
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2",
    x: 775,
    y: 1868,
    width: 370,
    height: 206,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feImage", {
    preserveAspectRatio: "none",
    x: 775,
    y: 1868,
    width: 370,
    height: 206,
    result: "image",
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzcwIiBoZWlnaHQ9IjIwNiIgdmlld0JveD0iMCAwIDM3MCAyMDYiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6IHVybCgjbGluZWFyLWdyYWRpZW50KTsKICAgICAgfQogICAgPC9zdHlsZT4KICAgIDxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50IiB4MT0iODIiIHgyPSIyODgiIHkyPSIyMDYiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KICAgICAgPHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjZmIwMDU0Ii8+CiAgICAgIDxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI2Y1NWIyYSIvPgogICAgPC9saW5lYXJHcmFkaWVudD4KICA8L2RlZnM+CiAgPHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iMzcwIiBoZWlnaHQ9IjIwNiIvPgo8L3N2Zz4K"
  }), /*#__PURE__*/React.createElement("feComposite", {
    result: "composite",
    operator: "in",
    in2: "SourceGraphic"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "blend",
    in2: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Top",
    className: "cls-1",
    d: "M784.25,1868h351.5a9.272,9.272,0,0,1,9.25,9.3v196.2s-85.69-4.14-167.425-51.14c-134.1-77.13-202.575-9.3-202.575-9.3V1877.3A9.272,9.272,0,0,1,784.25,1868Z",
    transform: "translate(-775 -1868)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Top-2",
    "data-name": "Top",
    className: "cls-2",
    d: "M1135.75,1868H784.25a9.283,9.283,0,0,0-9.25,9.32V2074s85.691-4.15,167.425-51.27c134.1-77.31,202.575-9.32,202.575-9.32V1877.32A9.283,9.283,0,0,0,1135.75,1868Z",
    transform: "translate(-775 -1868)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Left_Shape",
    "data-name": "Left Shape",
    className: "cls-3",
    d: "M775,2013s66.812-58.71,185,1c0,0-83.64,54.41-185,61v-62Z",
    transform: "translate(-775 -1868)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Right_Shape",
    "data-name": "Right Shape",
    className: "cls-3",
    d: "M1145,2011.87s-66.81-58.84-185,1c0,0,83.64,54.53,185,61.13",
    transform: "translate(-775 -1868)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2);
export default __webpack_public_path__ + "static/media/p2.dee997419c22f1cfc6e9aaab67f8780b.svg";
export { ForwardRef as ReactComponent };